/* ============================================================================
   CAPRIMAFFIA - HOME TOP - comportamiento
   Tesis: la pagina desciende de la noche al dia. Un unico momento de autoria,
   LA APERTURA (los planos del hero se cruzan con el scroll y el suelo blanco
   sube por encima), y movimiento de apoyo que solo explica estado o relacion.
   Todo el contenido es visible por defecto: si el JS falla, no se esconde nada.
   Solo se carga en la plantilla de inicio.

   3 oct 2026 - pasada de rendimiento: el lector de scroll de la APERTURA ya no
   lee el DOM en cada fotograma (ver `medir()`), que era la unica fuente de
   lecturas de layout por fotograma que quedaba en la home.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.add('ht-on');

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduced = RM.matches;
  var hasGSAP = function () {
    return typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';
  };

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return v < a ? a : (v > b ? b : v); };
  var pad2 = function (n) { n = String(n); return n.length < 2 ? '0' + n : n; };

  /* rAF compartido: un solo listener de scroll para toda la pagina */
  var readers = [];
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      for (var i = 0; i < readers.length; i++) readers[i]();
      ticking = false;
    });
  }
  function watch(fn) { readers.push(fn); fn(); }

  /* ------------------------------------------------------------- APERTURA
     POR PASOS. El scroll no dibuja el cruce: solo decide que plano manda.
     Un plano cambia cuando el gesto pasa del umbral (data-switch, % del
     recorrido de un plano) y vuelve atras con una banda muerta de por medio,
     asi no parpadea justo en el limite. El cruce lo hace el CSS con duracion
     fija (--ht-ap-dur), asi que SIEMPRE termina: no hay estado a medias.
     El scroll de la pagina no se toca en ningun momento: la seccion es alta
     y el hero va sticky dentro, asi que rueda, trackpad, teclado y dedo
     funcionan igual que en cualquier pagina.                               */
  function apertura() {
    var sec = $('#htAp');
    if (!sec) return;
    var vp = $('.ht-ap__vp', sec);
    var plates = $$('.ht-ap__plate', sec);
    var btns = $$('.ht-ap__idx button', sec);
    var nEl = $('#htApN');
    var n = plates.length;

    var num = function (a, d) { var v = parseFloat(sec.getAttribute(a)); return isNaN(v) ? d : v; };
    var STEP = num('data-step', 70) || 70;   // vh de scroll por plano
    var HOLD = num('data-hold', 40);         // vh de reposo del ultimo plano
    var SW = clamp(num('data-switch', 42), 10, 70) / 100;
    var HY = 0.1;                            // banda muerta, en planos

    /* un plano en px: sale de la geometria real, no de recalcular svh.
       🚨 3 oct 2026 — ESTO SE MEDIA EN CADA FOTOGRAMA DE SCROLL. El lector de
       `watch()` llamaba a `stepPx()` (dos `offsetHeight`) y leia `sec.offsetTop`
       en cada fotograma, DE TODA LA PAGINA, no solo del hero: tres lecturas de
       layout por fotograma durante los 8.300 px de la home. Ahora se mide una
       vez y se vuelve a medir solo cuando puede haber cambiado: al redimensionar,
       al cargar las fotos, al llegar las tipografias y si el alto de la seccion
       cambia de verdad (ResizeObserver con freno). El lector del scroll ya no
       toca el DOM: solo hace aritmetica.                                      */
    var SP = 0, TOP = 0;
    function medir() {
      if (!vp) { SP = 0; TOP = sec.offsetTop; return; }
      var span = sec.offsetHeight - vp.offsetHeight;
      var units = (n - 1) + (STEP > 0 ? HOLD / STEP : 0);
      SP = units > 0 && span > 0 ? span / units : 0;
      TOP = sec.offsetTop;
    }
    function stepPx() { return SP; }
    /* donde descansa cada plano: justo pasado su umbral */
    function stopOf(i) {
      return TOP + (i <= 0 ? 0 : (i - 1 + SW) * SP + 8);
    }
    medir();
    var mT = null;
    function medirLuego() {
      if (mT) clearTimeout(mT);
      mT = setTimeout(function () { mT = null; medir(); }, 160);
    }
    window.addEventListener('resize', medirLuego);
    window.addEventListener('orientationchange', medirLuego);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(medirLuego);
    $$('img', sec).forEach(function (im) {
      if (im.complete) return;
      im.addEventListener('load', medirLuego, { once: true });
      im.addEventListener('error', medirLuego, { once: true });
    });
    if ('ResizeObserver' in window) {
      var altoRef = 0;
      new ResizeObserver(function (e) {
        var h = Math.round(e[0].contentRect.height);
        if (Math.abs(h - altoRef) < 4) return;
        altoRef = h;
        medirLuego();
      }).observe(sec);
    }

    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        window.scrollTo({ top: stopOf(i), behavior: reduced ? 'auto' : 'smooth' });
      });
    });

    // Sin movimiento los planos se apilan: todos quedan a la vista y navegables.
    if (reduced || n < 2) {
      plates.forEach(function (p) {
        p.classList.add('is-on');
        p.removeAttribute('inert');
        p.setAttribute('aria-hidden', 'false');
      });
      if (nEl) nEl.textContent = '01';
      return;
    }

    sec.classList.add('is-live');
    var cur = -1;
    var z = 0;

    function paint(i) {
      if (i === cur) return;
      var first = cur < 0;
      cur = i;
      // el que entra va por encima: mientras se opaca tapa al que sale y el
      // cruce no se ve como dos fotos superpuestas
      plates[i].style.zIndex = ++z;
      if (first) plates.forEach(function (p) { p.style.transitionDuration = '0s'; });
      plates.forEach(function (p, k) {
        var on = k === i;
        p.classList.toggle('is-on', on);
        p.setAttribute('aria-hidden', on ? 'false' : 'true');
        // nada enfocable dentro de un plano que no se ve
        if (on) { p.removeAttribute('inert'); } else { p.setAttribute('inert', ''); }
      });
      if (first) {
        requestAnimationFrame(function () {
          plates.forEach(function (p) { p.style.transitionDuration = ''; });
        });
      }
      if (nEl) nEl.textContent = pad2(i + 1);
      btns.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
    }
    paint(0);

    watch(function () {
      var sp = SP;
      if (sp <= 0) return;
      var y = window.scrollY - TOP;
      var t = cur;
      while (t < n - 1 && y >= (t + SW) * sp) t++;
      while (t > 0 && y < (t - 1 + SW - HY) * sp) t--;
      if (t !== cur) paint(t);
    });
  }

  /* --------------------------------------------------------- ENTRADA HERO
     Una sola entrada autoral: el titular sube tras una mascara.             */
  function entrada() {
    var first = $('#htAp .ht-ap__plate');
    if (!first) return;
    var lines = $$('.ht-ln > span', first);
    var rest = $$('.ht-ap__row, .ht-ap__hud, .ht-ap__cue, .ht-ap__idx', $('#htAp'));
    if (reduced || !hasGSAP()) return;

    gsap.set(lines, { yPercent: 110 });
    gsap.set(rest, { opacity: 0, y: 12 });
    gsap.timeline()
      .to(lines, { yPercent: 0, duration: .95, ease: 'expo.out', stagger: .08 }, .1)
      .to(rest, { opacity: 1, y: 0, duration: .65, ease: 'power3.out', stagger: .07 }, .5);
  }

  /* ------------------------------------------------------------- PASARELA
     Escritorio con raton: el scroll vertical recorre el escaparate (una sola
     relacion, bien explicada). Tactil: scroll horizontal nativo con snap,
     que se siente mejor que cualquier pin.                                  */
  function pasarela() {
    var sec = $('#htPas');
    if (!sec) return;
    var track = $('.ht-pas__track', sec);
    var fill = $('.ht-pas__rail i', sec);
    if (!track) return;

    // barra de avance en tactil / sin GSAP
    function railFromScroll() {
      var max = track.scrollWidth - track.clientWidth;
      var p = max > 0 ? track.scrollLeft / max : 0;
      if (fill) fill.style.transform = 'scaleX(' + clamp(.08 + p * .92, 0, 1).toFixed(4) + ')';
    }
    track.addEventListener('scroll', function () {
      if (!track.__t) {
        track.__t = true;
        requestAnimationFrame(function () { railFromScroll(); track.__t = false; });
      }
    }, { passive: true });
    railFromScroll();

    if (reduced || !hasGSAP()) return;

    ScrollTrigger.matchMedia({
      '(min-width: 1025px) and (pointer: fine)': function () {
        sec.classList.add('is-pinned');
        var dist = function () { return Math.max(0, track.scrollWidth - window.innerWidth + 40); };
        var tw = gsap.to(track, {
          x: function () { return -dist(); },
          ease: 'none',
          scrollTrigger: {
            trigger: sec,
            start: 'top top',
            end: function () { return '+=' + dist(); },
            pin: true,
            scrub: .6,
            invalidateOnRefresh: true,
            anticipatePin: 1,
            onUpdate: function (s) {
              if (fill) fill.style.transform = 'scaleX(' + clamp(.08 + s.progress * .92, 0, 1).toFixed(4) + ')';
            }
          }
        });
        return function () {
          sec.classList.remove('is-pinned');
          tw.scrollTrigger && tw.scrollTrigger.kill();
          tw.kill();
          gsap.set(track, { clearProps: 'transform' });
          railFromScroll();
        };
      }
    });
  }

  /* ---------------------------------------------------------------- PLANTA
     Relacion: la fila que se recorre manda sobre el visor. Con raton, el
     hover; con teclado, el foco; al bajar, la fila que entra en pantalla.   */
  function planta() {
    var sec = $('#htPl');
    if (!sec) return;
    var rows = $$('.ht-pl__row', sec);
    var shots = $$('.ht-pl__stage img', sec);
    var cap = $('.ht-pl__cap', sec);
    if (!rows.length || !shots.length) return;

    var cur = -1;
    function show(i) {
      if (i === cur || i < 0 || i >= shots.length) return;
      cur = i;
      shots.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
      rows.forEach(function (r, k) { r.classList.toggle('is-on', k === i); });
      if (cap) cap.textContent = rows[i].getAttribute('data-cap') || '';
    }
    show(0);

    rows.forEach(function (r, i) {
      r.addEventListener('mouseenter', function () { show(i); });
      r.addEventListener('focus', function () { show(i); });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) show(rows.indexOf(e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      rows.forEach(function (r) { io.observe(r); });
    }
  }

  /* ----------------------------------------------------------------- BANDA
     Bucle continuo; parado mientras no se ve (nada corre fuera de pantalla).
     8 oct 2026: antes la movia GSAP escribiendo el transform en cada
     fotograma DESDE EL HILO PRINCIPAL, tambien mientras se usaba el anillo
     (medido: un recalculo de estilo por fotograma solo para la banda). Ahora
     es una animacion de Web Animations sobre `transform`, que la corre el
     compositor: el hilo principal no hace nada mientras gira.            */
  function banda() {
    var tr = $('#htBand');
    if (!tr || reduced) return;
    var half = tr.scrollWidth / 2;
    if (half < 10) return;
    var secs = parseFloat(tr.getAttribute('data-secs'));
    if (isNaN(secs) || secs <= 0) secs = 28;
    if (!tr.animate) return;
    var an = tr.animate(
      [{ transform: 'translate3d(0,0,0)' }, { transform: 'translate3d(' + (-Math.round(half)) + 'px,0,0)' }],
      { duration: secs * 1000, iterations: Infinity, easing: 'linear' }
    );
    an.pause();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.isIntersecting ? an.play() : an.pause(); });
      }).observe(tr.parentNode);
    } else {
      an.play();
    }
  }

  /* -------------------------------------------------------------- REVELADO
     Apoyo, no espectaculo: una sola entrada por bloque, nunca la misma en
     todas las secciones (los titulares suben tras mascara, las rejillas
     aparecen escalonadas una sola vez).                                     */
  function revelado() {
    var items = $$('.ht-rv > span');
    var blocks = $$('.ht-reveal');
    if (reduced || !hasGSAP()) {
      blocks.forEach(function (b) { b.classList.add('is-in'); });
      return;
    }
    items.forEach(function (sp) {
      gsap.fromTo(sp, { yPercent: 108 }, {
        yPercent: 0, duration: .85, ease: 'expo.out',
        scrollTrigger: { trigger: sp.parentNode, start: 'top 88%', once: true }
      });
    });
    blocks.forEach(function (b) {
      var kids = $$('[data-ht-stagger]', b);
      var targets = kids.length ? kids : [b];
      gsap.fromTo(targets, { opacity: 0, y: 18 }, {
        opacity: 1, y: 0, duration: .7, ease: 'power3.out',
        stagger: { each: .06, amount: Math.min(.5, targets.length * .06) },
        onStart: function () { b.classList.add('is-in'); },
        scrollTrigger: { trigger: b, start: 'top 86%', once: true }
      });
    });
  }

  /* ----------------------------------------------------------- PARALAJE DOS
     Solo en el dossier y solo en escritorio: 24 px de recorrido, nada mas.  */
  function dossier() {
    if (reduced || !hasGSAP()) return;
    ScrollTrigger.matchMedia({
      '(min-width: 860px)': function () {
        $$('.ht-do__media img').forEach(function (im) {
          gsap.fromTo(im, { yPercent: -3.5 }, {
            yPercent: 3.5, ease: 'none',
            scrollTrigger: { trigger: im.parentNode, start: 'top bottom', end: 'bottom top', scrub: true }
          });
        });
      }
    });
  }

  /* -------------------------------------------------------------- QUICK-ADD
     Usa el <product-form-component> del propio tema: el cajon del carrito y
     el contador se comportan exactamente igual que en la ficha de producto.
     Aqui solo se fija la variante elegida antes de que el formulario se envie.*/
  function compra() {
    document.addEventListener('click', function (ev) {
      var size = ev.target.closest && ev.target.closest('[data-ht-variant]');
      if (!size || size.disabled) return;
      var form = size.closest('form');
      var input = form && form.querySelector('[data-ht-variant-input]');
      if (input) input.value = size.getAttribute('data-ht-variant');
      var card = size.closest('.ht-card');
      if (card) {
        var btn = card.querySelector('.ht-card__add');
        if (btn) {
          btn.classList.add('is-done');
          setTimeout(function () { btn.classList.remove('is-done'); }, 1400);
        }
      }
    }, true);
  }

  /* ------------------------------------------- nada se mueve fuera de pantalla
     En la home quedaban dos animaciones CSS en bucle infinito dentro del hero:
     `htSweep` (la barrita de 40 px del rotulo «baja», 2,2 s) y `htPulse` (el
     punto de stock en vivo, 2,1 s). Seguian corriendo con el hero muy por
     encima de la pantalla. Se paran con un IntersectionObserver -que no cuesta
     nada- y se reanudan al volver. La banda del dossier NO hace falta: la mueve
     GSAP y ya se paraba sola con `onToggle` de ScrollTrigger. Se incluye
     tambien `.cm-ticker` por si algun dia cae en la portada.                 */
  function pausarFuera() {
    if (!('IntersectionObserver' in window)) return;
    var zonas = $$('.ht-ap, .cm-ticker');
    if (!zonas.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.target.classList.toggle('cm-anim-off', !e.isIntersecting); });
    }, { rootMargin: '120px 0px' });
    zonas.forEach(function (z) { io.observe(z); });
  }

  /* ------------------------------------------------------------------ ARRANQUE */
  function start() {
    // sin motor de animacion o con movimiento reducido no se oculta nada
    if (!hasGSAP() || reduced) root.classList.remove('ht-js');
    if (hasGSAP()) gsap.registerPlugin(ScrollTrigger);
    apertura();
    entrada();
    pasarela();
    planta();
    banda();
    revelado();
    dossier();
    compra();
    pausarFuera();
    window.addEventListener('scroll', onScroll, { passive: true });
    /* el resize solo repinta; las MEDIDAS las rehace `medirLuego()` de la
       apertura, con freno, para no leer layout en el propio evento */
    window.addEventListener('resize', onScroll, { passive: true });
    RM.addEventListener && RM.addEventListener('change', function (e) { reduced = e.matches; });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
